import { Box, Button, ButtonProps, DialogContent, Grid, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import { Dialog } from '../../components/dialog';
import { ProgressButton } from '../../inputs/progress-button';

type Props = {
  title: string;
  content: ReactNode;
  cancelLabel?: string;
  onCancel: () => void;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose?: () => void;
  inProgress?: boolean;
  errorMessage?: string | null;
};

const ConfirmationDlg: FC<Props> = ({
  onClose,
  title,
  content,
  cancelLabel,
  onCancel,
  confirmLabel,
  onConfirm,
  inProgress,
  errorMessage,
}: Props) => {
  return (
    <Dialog title={title} open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent dividers>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="body1" align="center" color="textSecondary">
              {content}
            </Typography>
          </Grid>
          {errorMessage && (
            <Grid item xs={12}>
              <Typography variant="inherit" align="center" color="error">
                {errorMessage}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <ProgressButton
              type="button"
              size="large"
              color={'danger' as ButtonProps['color']}
              variant="contained"
              fullWidth
              onClick={onConfirm}
              progress={inProgress ?? false}
            >
              {confirmLabel ?? 'Ok'}
            </ProgressButton>
            <Box mt={1}>
              <Button size="large" onClick={onCancel} fullWidth>
                {cancelLabel ?? 'Cancel'}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export { ConfirmationDlg };
